export default __webpack_public_path__ + "static/media/tituloES.f5316bfc.png";